import React from 'react';
import '../App.css';

const Japan = () => {
  return (
    <>
      <header className="english-header">
        <div className="header-left">
          <div className="header-logo">
            <a href="https://www.iwatsukaseika.co.jp/" target="_blank">
              <img src="../images/logo.png" alt="Iwatsuka Seika Europe"></img>
            </a>
          </div>
        </div>
        <div className="header-right">
          <div className="header-button conversion-button">
            <a href="/contact">お問い合わせはこちら</a>
          </div>
          <div className="header-language text-button">
            <a href="/">EN</a>
          </div>
        </div>
      </header>
      <main className="english-main pc">
        <section className="main">
          <img src="../images/pc/jp/main_top.png" alt=""></img>
        </section>
        <section className="introduction back-orange">
          <img src="../images/pc/jp/introduction.png" alt=""></img>
        </section>
        <section className="feature">
          <img src="../images/pc/jp/commitment.png" alt=""></img>
          <div class="movie-box-green">
            <img className="snack-left" src="../images/pc/en/snack-left.png" alt=""></img>
            <video className="video-snack" autoPlay loop muted playsInline src="../videos/beika.mp4" type="video/mp4">Your browser does not support the video tag.</video>
            <img className="snack-right" src="../images/pc/en/snack-right.png" alt=""></img>
          </div>
        </section>
        <section className="snack">
          <img src="../images/pc/jp/snacks.png" alt=""></img>
        </section>
        <section className="contact">
          <a href="/contact">
            <img src="../images/pc/jp/contact.png" alt=""></img>
          </a>
        </section>
        <section className="description">
          <img src="../images/pc/jp/description.png" alt=""></img>
        </section>
        <section className="about-us">
          <img src="../images/pc/jp/about_us.png" alt=""></img>
          <div class="movie-box">
            <video controls src="../videos/about.mp4" type="video/mp4">Your browser does not support the video tag.</video>
          </div>
          <img src="../images/pc/jp/about_us_bottom.png" alt=""></img>
        </section>
        <section className="contact">
          <a href="/contact">
            <img src="../images/pc/jp/contact.png" alt=""></img>
          </a>
        </section>
      </main >
      <main className="english-main sp">
        <section className="main">
          <img src="../images/sp/jp/main_top.png" alt=""></img>
        </section>
        <section className="introduction">
          <img src="../images/sp/jp/introduction.png" alt=""></img>
        </section>
        <section className="feature">
          <img src="../images/sp/jp/commitment.png" alt=""></img>
          <div className="movie-box-green">
            <video className="video-snack-sp" controls src="../videos/beika-sp.mp4" type="video/mp4">Your browser does not support the video tag.</video>
          </div>
          <img src="../images/sp/jp/feature-bottom-sp.png" alt=""></img>
        </section>
        <section className="snack">
          <img src="../images/sp/jp/snacks.png" alt=""></img>
        </section>
        <section className="contact">
          <a href="/contact">
            <img src="../images/sp/jp/contact.png" alt=""></img>
          </a>
        </section>
        <section className="description">
          <img src="../images/sp/jp/description.png" alt=""></img>
        </section>
        <section className="about-us">
          <img src="../images/sp/jp/about_us.png" alt=""></img>
          <div class="movie-box">
            <video controls src="../videos/about.mp4" type="video/mp4">Your browser does not support the video tag.</video>
          </div>
          <img src="../images/sp/jp/about_us_bottom.png" alt=""></img>
        </section>
        <section className="contact">
          <a href="/contact">
            <img src="../images/sp/jp/contact.png" alt=""></img>
          </a>
        </section>
      </main>
      <footer>
        <div className="footer-box">
          <div className="footer-box__logo">
            <a href="https://www.iwatsukaseika.co.jp/" target="_blak"><img src="../images/logo.png" alt="Iwatsuka Europe"></img></a>
          </div>
          <div className="footer-box__adress">
            <address>
              <p>IWATSUKA CONFECTIONERY CO., LTD.</p>
              <dl><dt>Address :</dt><dd>Prinzenalle 7, 40549 Düsseldorf Germany</dd></dl>
              <dl><dt>Mail :</dt><dd><div class="text-button"><a href="mailto:contact@iwatsuka.eu">contact@iwatsuka.eu</a></div></dd></dl>
            </address>
          </div>
        </div>
        <div className="footer-copy">
          <small>© 2025<script type="text/javascript">myDate = new Date() ;myYear = myDate.getFullYear ();document.write(myYear);</script> Iwatsuka Seika Europe</small>
        </div>
      </footer>
    </>
  );
};

export default Japan